<script setup>
import {ref, onMounted, getCurrentInstance} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from '../../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../../stores/pageLoading";
import _ from "lodash";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import fileService from "@/services/fileService";
import moment from "moment/moment";
import KSAInput from "@/components/ui-components/input/KSAInput.vue";
import mypageUserService from "@/pages/user/services/mypage/mypageUserService";
import { useAlertStore } from '../../../../../../stores/alertStore';
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
const { $alert, $confirm } = useAlertStore();

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $regex, $gb, $fileSize } = globals;

const ojfId = ref(route.query.ojfId || '');

const user = ref({});
const residenceAreaRef = ref(null); // 사업장소재지
const ciFileNameSize = ref(null); // 파일명 + 용량
const bizFileNameSize = ref(null); // 파일명 + 용량
const corpFileNameSize = ref(null); // 파일명 + 용량
const createCorpFileNameSize = ref(null); // 파일명 + 용량
const createCorpIntroMovFileNameSize = ref(null); // 파일명 + 용량

onMounted(()=>{
  retrieveUserInfo();
})

const createCorp = ref({
  "corpInfoAgreePrivacyYn": false,  // 약관동의유무
  "introMovGb": "01", // 기업소개영상구분 01 영상 업로드 02 유튜브 영상(URL)
  "introMovName": "", // 기업소개영상
  "introMovSize": "",
  "introMovDir": "",
  "introYoutubeUrl": "" // 유튜브 URL

})

const inputError = ref({
  // 기업 기본 정보
  bizNum: "", // 사업자등록번호
  corpName: "", // 기업명
  ceoName: "", // 대표자명
  residenceArea: "", // 사업장소재지
  bizType: "", // 업종
  industryGb: "", // 산업군
  corpGb: "", // 기업형태
  foundYm: "", // 창립연월
  employeeNumGb: "", // 사원수
  salesAmtGb: "", // 매출액
  corpPublicYn: "", // 상장여부
  corpPublicGb: "", // 상장구분
  ciImg: "", // 로고이미지(CI)
  bizLicense: "", // 사업자등록증
  corpInfoAgreePrivacyYn: false, // 동의
})

// 상장여부 초기화
const resetCorpPublic = (val) => {
  if (val === 'N') {
    createCorp.value.corpPublicGb = ''
    createCorp.value.corpPublicText = ''
  }
}

// 상장 기타 초기화
const resetCorpPublicText = (val) => {
  if (val === '05') {
    createCorp.value.corpPublicText = ''
  }
}

// 기업소개영상 업로드 양식 초기화
const resetFile = (val) => {
  if (val === 'N') {
    createCorp.value.introMovName = ''
    createCorp.value.introMovSize = ''
    createCorp.value.introMovDir = ''
    createCorpIntroMovFileNameSize.value = ''
  } else {
    createCorp.value.introYoutubeUrl = ''
  }
}

// 산업군 기타 초기화
const resetIndustryText = (val) => {
  inputError.value.industryGb = ''
  if (val === '06') {
    createCorp.value.industryText = ''
  }
}

// 기업형태 기타 초기화
const resetCorpText = (val) => {
  inputError.value.corpGb = ''
  if (val === '05') {
    createCorp.value.corpText = ''
  }
}

// 사용자 정보 조회
const retrieveUserInfo = () => {
  loadingStore.loading = true;
  mypageUserService.retrieveUserInfo()
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          // await nextTick();
          const result = res.data.result.corporation;
          // console.log('사용자', result);

          // 사업자등록번호
          if(result.bizNum ) {
            const bizNum = result.bizNum;
            if(bizNum) {
              result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
            }
          }

          // 사업장소재지
          if(result.residenceArea1 && result.residenceArea2) {
            residenceAreaRef.value.initSelectedOption(result.residenceArea1, result.residenceArea2)
          }

          // 창립연월
          if(result.foundYm ) {
            const foundYm = result.foundYm;
            if(foundYm) {
              result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
            }
          }

          if(result.ciImgName){
            const originFileSize = $fileSize(result.ciImgSize);
            ciFileNameSize.value = result.ciImgName + '  ' + originFileSize;
          }

          if(result.bizLicenseName){
            const originFileSize = $fileSize(result.bizLicenseSize);
            bizFileNameSize.value = result.bizLicenseName + '  ' + originFileSize;
          }

          if(result.corpIntroName){
            const originFileSize = $fileSize(result.corpIntroSize);
            corpFileNameSize.value = result.corpIntroName + '  ' + originFileSize;
          }

          user.value = result;
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

const clearErrorFocus = () => {
  try {
    document.querySelectorAll('.error-focus').forEach(el => el.classList.remove('error-focus'))
  } catch(e) {}
}

const focusAndScroll = (el) => {
  if (!el) return
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch(e) {}
  try { el.focus && el.focus({ preventScroll: true }) } catch(e) {}
  try { el.classList && el.classList.add('error-focus') } catch(e) {}
}

const highlightFirstError = () => {
  if (inputError.value.bizNum) {
    const el = document.querySelector('input[placeholder*="10자리"]') || document.querySelector('input[placeholder*="숫자"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpName) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('기업명'))
    const el = th ? th.parentElement.querySelector('input, .text-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.ceoName) {
    const el = document.querySelector('input[placeholder*="대표명"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.residenceArea) {
    const el = residenceAreaRef.value?.$el || Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사업장소재지'))?.parentElement.querySelector('.select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.bizType) {
    const el = document.querySelector('input[placeholder*="업종"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.industryGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('산업군'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('기업형태'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.foundYm) {
    const el = document.querySelector('input[placeholder*="YYYY.MM"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.employeeNumGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사원수'))
    const el = th ? th.parentElement.querySelector('.select') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.salesAmtGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('매출액'))
    const el = th ? th.parentElement.querySelector('.select') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpPublicYn) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('상장여부'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpPublicGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('상장여부'))
    const row = th ? th.parentElement.nextElementSibling : null
    const el = row ? row.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.homeUrl) {
    const el = document.querySelector('input[placeholder*="홈페이지 URL"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.ciImg) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('로고이미지'))
    const el = th ? th.parentElement.querySelector('input[placeholder*="파일 선택"], .input.icon') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.bizLicense) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사업자등록증'))
    const el = th ? th.parentElement.querySelector('input[placeholder*="파일 선택"], .input.icon') : null
    focusAndScroll(el)
    return
  }
  if (!createCorp.value.corpInfoAgreePrivacyYn) {
    const el = document.querySelector('.terms-wrap') || document.querySelector('.terms-wrap input[type="checkbox"]')
    focusAndScroll(el)
    return
  }
}

// 기업 정보 및 참가 신청 등록
const saveCorp = async () => {
  clearErrorFocus();
  let isInvalid = false;

  // 기본 기본 정보
  // 사업자등록번호
  inputError.value.bizNum = '';

  const bizNum = user.value.bizNum ? user.value.bizNum.replace('-','').replace('-','') : user.value.bizNum;
  if(!bizNum || bizNum.length !== 10) {
    inputError.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
    isInvalid = true;
  }

  // 대표자명, 사업장소재지, 업종
  const { corpName, ceoName, residenceArea1, residenceArea2, bizType } = user.value;
  inputError.value.corpName = '';
  inputError.value.ceoName = '';
  inputError.value.residenceArea = '';
  inputError.value.bizType = '';

  // 기업명
  if(!corpName) {
    inputError.value.corpName = '기업명을 입력하세요.';
    isInvalid = true;
  }

  // 대표자명
  if(!ceoName) {
    inputError.value.ceoName = '대표자명을 입력하세요.';
    isInvalid = true;
  }

  //사업장소재지
  if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
      (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
    inputError.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
    isInvalid = true;
  }

  // 업종
  if(!bizType) {
    inputError.value.bizType = '업종을 입력하세요.';
    isInvalid = true;
  }

  // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
  const { industryGb, corpGb, employeeNumGb, salesAmtGb } = user.value;
  inputError.value.industryGb = '';
  inputError.value.corpGb = '';
  inputError.value.foundYm = '';
  inputError.value.employeeNumGb = '';
  inputError.value.salesAmtGb = '';


  // 산업군
  let industryText = user.value.industryText;
  if(!industryGb) {
    inputError.value.industryGb = '산업군을 선택하세요.';
    isInvalid = true;
  } else if(industryGb === '06' && !industryText) {
    inputError.value.industryGb = '기타 산업군을 입력하세요.';
    isInvalid = true;
  } else if (industryGb !== '06') {
    industryText = '';
  }

  // 기업형태
  let corpText = user.value.corpText;
  if(!corpGb) {
    inputError.value.corpGb = '기업형태를 선택하세요.';
    isInvalid = true;
  } else if(corpGb === '05' && !corpText) {
    inputError.value.corpGb = '기타 기업형태를 입력하세요.';
    isInvalid = true;
  } else if (corpGb !== '05') {
    corpText = '';
  }

  // 창립연월
  const foundYm = moment(user.value.foundYm.replace('.', '')).format("YYYYMM")
  if(!foundYm) {
    inputError.value.foundYm = '창립연월을 입력하세요.';
    isInvalid = true;
  } else if (foundYm) {
    if(foundYm.length !== 6) {
      inputError.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
      isInvalid = true;
    } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
        // || Number(nowYm) < Number(startYm)  // 미래 기간
    ) {
      inputError.value.foundYm = '올바른 기간을 입력하세요.';
      isInvalid = true;
    }
  }

  // 사원수(인원구분)
  if(!employeeNumGb || employeeNumGb === '00') {
    inputError.value.employeeNumGb = '사원수를 선택하세요.';
    isInvalid = true;
  }

  // 매출액
  if(!salesAmtGb || salesAmtGb === '00') {
    inputError.value.salesAmtGb = '매출액을 선택하세요.';
    isInvalid = true;
  }

  // 상장, 홈페이지 url
  const { corpPublicYn, corpPublicGb } = user.value;
  inputError.value.corpPublicYn = '';
  inputError.value.corpPublicGb = '';

  // 상장
  let corpPublicText = user.value.corpPublicText;
  if(!corpPublicYn) {
    inputError.value.corpPublicYn = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && !corpPublicGb) {
    inputError.value.corpPublicGb = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
    inputError.value.corpPublicGb = '기타 상장을 입력하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
    corpPublicText = '';
  }

  // 로고이미지(CI)
  const { ciImgName, ciImgSize, ciImgDir } = user.value;
  inputError.value.ciImg = '';

  if(!ciImgName || !ciImgSize || !ciImgDir) {
    inputError.value.ciImg = '로고이미지 파일을 선택하세요.';
    isInvalid = true;
  }

  // 사업자등록증
  const { bizLicenseName, bizLicenseSize, bizLicenseDir } = user.value;
  inputError.value.bizLicense = '';

  if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
    inputError.value.bizLicense = '사업자등록증 파일을 선택하세요.';
    isInvalid = true;
  }

  const { introMovGb, introMovName, introMovSize, introMovDir, introYoutubeUrl } = createCorp.value;

  // 약관 동의
  const corpInfoAgreePrivacyYn = createCorp.value.corpInfoAgreePrivacyYn ? 'Y' : 'N';
  inputError.value.corpInfoAgreePrivacyYn  = false;

  if(isInvalid) {
    // $alert("필수 입력사항을 확인해 주세요.");
    highlightFirstError();
    isInvalid = true;
  } else if(corpInfoAgreePrivacyYn === 'N') {
    $alert("필수 약관을 확인하고 동의해 주세요.");
    highlightFirstError();
    isInvalid = true;
  }

  // 저장 처리
  if(!isInvalid) {
    let paramObj = {
      bizNum: user.value.bizNum ? user.value.bizNum.replace('-','').replace('-','') : user.value.bizNum,
      corpName: user.value.corpName,
      ceoName: user.value.ceoName,
      residenceArea1: user.value.residenceArea1,
      residenceArea2: user.value.residenceArea2,
      bizType: user.value.bizType,
      industryGb: user.value.industryGb,
      industryText: industryText,
      corpGb: user.value.corpGb,
      corpText: corpText,
      foundYm: user.value.foundYm ? user.value.foundYm.replace('.','').replace('.','') : user.value.foundYm,
      employeeNumGb: user.value.employeeNumGb,
      salesAmtGb: user.value.salesAmtGb,
      corpPublicYn: user.value.corpPublicYn,
      corpPublicGb: user.value.corpPublicGb,
      corpPublicText: corpPublicText,
      homeUrl: user.value.homeUrl,
      ciImgName: user.value.ciImgName,
      ciImgSize: user.value.ciImgSize,
      ciImgDir: user.value.ciImgDir,
      bizLicenseName: user.value.bizLicenseName,
      bizLicenseSize: user.value.bizLicenseSize,
      bizLicenseDir: user.value.bizLicenseDir,
      corpIntro: user.value.corpIntro,
      corpHistory: user.value.corpHistory,
      corpIntroName: user.value.corpIntroName,
      corpIntroSize: user.value.corpIntroSize,
      corpIntroDir: user.value.corpIntroDir,
      introMovGb,
      introMovName,
      introMovSize,
      introMovDir,
      introYoutubeUrl,
      corpInfoAgreePrivacyYn,
    }

    loadingStore.loading = true;
      mypageCorpInfoService.createCorpInfo(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const ok = await $alert(["기업정보 등록이 완료되었습니다.","등록된 기업정보는","추후 언제든 수정이 가능합니다."]);
            if(ok) {
              router.push({name: 'MypageCorpPromotion'});
            } else {
              $alert("기업정보 등록이 취소되었습니다.");
              goBack();
            }
          }
        })
        .catch( (res) =>  {
          alert([res.response.data.result.message]);
          loadingStore.loading = false;
        });
  }
}

const clickCancel = async () => {
  $alert("기업정보 등록이 취소되었습니다.");
  router.push({name: 'MatchingCorpPromotion'})
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  const filteredValue = filterText(event.target.value).slice(0, 200); // 글자수 제한 200자

  // 필터링된 값 적용
  createCorp.value[key] = filteredValue;

  // 유효성 체크
  if (!filteredValue) {
    inputError.value[key] = '참가 목적을 입력하세요.';
  } else if (filteredValue.length > 200) {
    inputError.value[key] = '참가 목적은 최대 200자까지 입력하세요.';
  } else {
    inputError.value[key] = ''; // 유효성 통과시 에러 메시지 초기화
  }
}

// 사업자등록번호
const bizNumInput = ref('')

const formatBizNum = (event) => {
  inputError.value.bizNum = ''
  // 숫자만 필터링
  bizNumInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (bizNumInput.value.length >= 5) {
    createCorp.bizNum = `${bizNumInput.value.slice(0, 3)}-${bizNumInput.value.slice(0,2)}-${bizNumInput.value.slice(5)}`
  } else {
    createCorp.bizNum = bizNumInput.value
  }
}

const validateText = (key) => {
  if (key === 'corpName') {
    if (user.value.corpName.trim() === '') {
      inputError.value.corpName = '기업명을 입력하세요.';
    } else if (user.value.corpName.length > 500) {
      inputError.value.corpName = '기업명은 최대 500자까지 입력하세요.';
    } else {
      inputError.value.corpName = '';
    }
  } else if (key === 'ceoName') {
    if (user.value.ceoName.trim() === '') {
      inputError.value.ceoName = '대표자명을 입력하세요.';
    } else if (user.value.ceoName.length > 50) {
      inputError.value.ceoName = '대표자명은 최대 50자까지 입력하세요.';
    } else {
      inputError.value.ceoName = '';
    }
  } else if (key === 'bizType') {
    if (user.value.bizType.trim() === '') {
      inputError.value.bizType = '업종을 입력하세요.';
    } else if (user.value.bizType.length > 100) {
      inputError.value.bizType = '업종은 최대 100자까지 입력하세요.';
    } else {
      inputError.value.bizType = '';
    }
  } else if (key === 'foundYm') {
    inputError.value.foundYm = '' ? '창립연월을 입력하세요.' : '';
  } else if (key === 'homeUrl') {
    if (user.value.homeUrl.length > 200) {
      inputError.value.homeUrl = '홈페이지 URL은 최대 200자까지 입력하세요.';
    } else {
      inputError.value.homeUrl = '';
    }
  } else if (key === 'corpHistory') {
    // console.log(user.value.corpHistory, '1111')
    // if (user.value.corpHistory.length > 4000) {
    //   console.log(user.value.corpHistory, '1111')
    //   inputError.value.corpHistory = '주요 연혁은 최대 4000자까지 입력하세요.';
    // } else {
    //   console.log(user.value.corpHistory, '1111')
    //   inputError.value.corpHistory = '';
    // }
  }
}

const optionData = (key) => {
  if (key === 'intvGb') {
    inputError.value.intvGb = '' ? '면접 방식을 선택하세요.' : '';
  }
}

// 사업장소재지
const onSelectedArea1Option = (option) => {
  user.value.residenceArea1 = option;
  inputError.value.residenceArea = '';
}

const onSelectedArea2Option = (option) => {
  user.value.residenceArea2 = option;
  inputError.value.residenceArea = '';
}

// 창립연월
const rawInput = ref('')

const formatDate = (event) => {
  inputError.value.foundYm = ''
  // 숫자만 필터링
  rawInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (rawInput.value.length >= 5) {
    user.value.foundYm = `${rawInput.value.slice(0, 4)}.${rawInput.value.slice(4)}`
  } else {
    user.value.foundYm = rawInput.value
  }
}


// 매출액
const clickSalesAmtGb = (option) => {
  user.value.salesAmtGb = option.value;
  inputError.value.salesAmtGb = '';
}


// 로고이미지(CI) 업로드
const uploadFileCiImg = (createCorp) => {
  inputError.value.ciImg = ''
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'ciImg',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.ciImgName = result.originalFilename;
            createCorp.ciImgSize = result.fileSize;
            createCorp.ciImgDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            ciFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 로고이미지(CI) 삭제
const removeFileCiImg = (createCorp) => {
  createCorp.ciImgName = '';
  createCorp.ciImgSize = '';
  createCorp.ciImgDir = '';
  inputError.value.ciImg = '';
  ciFileNameSize.value = '';
}

// 사업자등록증 업로드
const uploadFileBizLicense = (createCorp) => {
  inputError.value.bizLicense = ''
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'bizLicense',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.bizLicenseName = result.originalFilename;
            createCorp.bizLicenseSize = result.fileSize;
            createCorp.bizLicenseDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            bizFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 사업자등록증 삭제
const removeFileBizLicense = (createCorp) => {
  createCorp.bizLicenseName = '';
  createCorp.bizLicenseSize = '';
  createCorp.bizLicenseDir = '';
  inputError.value.bizLicense = '';
  bizFileNameSize.value = '';
}

// 기업소개서 업로드
const uploadFileCorpIntro = (createCorp) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpIntro',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.corpIntroName = result.originalFilename;
            createCorp.corpIntroSize = result.fileSize;
            createCorp.corpIntroDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            corpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 기업소개서 삭제
const removeFileCorpIntro = (createCorp) => {
  createCorp.corpIntroName = '';
  createCorp.corpIntroSize = '';
  createCorp.corpIntroDir = '';
  corpFileNameSize.value = '';
}

// 회사 소개 영상 업로드
const uploadFileCorpIntroMov = (createCorp) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'corpInfoURL',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.introMovName = result.originalFilename;
            createCorp.introMovSize = result.fileSize;
            createCorp.introMovDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            createCorpIntroMovFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 회사 소개 영상 삭제
const removeFileCorpIntroMov = (createCorp) => {
  createCorp.introMovName = '';
  createCorp.introMovSize = '';
  createCorp.introMovDir = '';
  createCorpIntroMovFileNameSize.value = '';
  inputError.value.introMov = '';
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content" :style="{width:'100% !important'}">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>기업정보 등록</h3>
            </div>
            <p class="mt-xs">기업 정보는 등록과 동시에 &lt;기업 홍보관&gt;페이지에 공개되므로 반드시 실제 정보를 입력하시기 바랍니다. (<span class="red">*</span>표시는 필수 입력사항입니다.)</p>
            <p class="mt-xs">등록된 기업정보는 [마이페이지 &gt; 기업홍보관 현황]에서 관리가 가능합니다.</p>
            <div class="lecture-detail">
              <!-- s : 기업 기본 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 기본 정보</th>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록번호</th>
                    <td>
                      <KSAInput class="text-box" @input="formatBizNum" v-model="user.bizNum" maxLength="15" placeholder="10자리 숫자 입력" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizNum }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업명</th>
                    <td>
                      <KSAInput class="text-box" @input="validateText('corpName')" maxLength="500" v-model="user.corpName" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">대표자명</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.ceoName" @input="validateText('ceoName')" maxLength="50" placeholder="대표명을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.ceoName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업장소재지</th>
                    <td>
                      <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">업종</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.bizType" @input="validateText('bizType')" maxLength="50" placeholder="업종을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizType }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">산업군</th>
                    <td>
                      <template v-for="option in $gb.INDUSTRY_GB">
                        <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="user.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && user.industryGb == option.value" >
                          <KSAInput class="text-box" v-model="user.industryText" placeholder="기타 산업군을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.industryGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업형태</th>
                    <td>
                      <template v-for="option in $gb.CORP_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="user.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                        <div class="etc-box" v-if="option.label === '기타' && user.corpGb == option.value" >
                          <KSAInput class="text-box" v-model="user.corpText" placeholder="기타 기업형태를 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">창립연월</th>
                    <td>
                      <KSAInput class="text-box" @input="formatDate" v-model="user.foundYm" placeholder="YYYY.MM" maxlength="7" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.foundYm }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사원수</th>
                    <td>
                      <KSASelect v-if="!user.employeeNumGb" class="select" v-model="user.employeeNumGb" :options="[{ label: '선택', value: '00' }, ...$gb['EMPLOYEE_NUM_GB']]" />
                      <KSASelect v-else class="select" v-model="user.employeeNumGb" :options="$gb['EMPLOYEE_NUM_GB']" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.employeeNumGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">매출액</th>
                    <td>
                      <KSASelect v-if="!user.salesAmtGb" class="select" :options="[{ label: '선택', value: '' }, ...$gb['SALES_AMT_GB']]" @selectOption="clickSalesAmtGb"/>
                      <KSASelect v-else class="select" :options="$gb['SALES_AMT_GB']" @selectOption="clickSalesAmtGb"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.salesAmtGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark" rowspan="2">상장여부</th>
                    <td>
                      <KSARadioButton class="check-box mr-lg" label="상장" v-model="user.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                      <KSARadioButton class="check-box mr-lg" label="비상장" v-model="user.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicYn }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td v-if="user.corpPublicYn === 'Y'">
                      <template v-for="option in $gb.CORP_PUBLIC_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="user.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && user.corpPublicGb == option.value" >
                          <KSAInput class="text-box" v-model="user.corpPublicText" placeholder="기타 상장을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>홈페이지 URL</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.homeUrl" @input="validateText('homeUrl')" maxLength="200" placeholder="홈페이지 URL을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.homeUrl }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">로고이미지(CI)</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(user)" />
                        <KSAInput class="input icon" v-model="ciFileNameSize" @input="validateText('ciImg')" placeholder="파일 선택(1200px X 265px, 300DPI 이미지를 권장합니다.)" disabled />
                        <button class="delete" @click="removeFileCiImg(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.ciImg }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록증</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(user)" />
                        <KSAInput class="input icon" v-model="bizFileNameSize" placeholder="영상 파일 선택" disabled />
                        <button class="delete" @click="removeFileBizLicense(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizLicense }}</small>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 기본 정보 -->
              <!-- s : 기업 추가 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 추가 정보</th>
                  </tr>
                  <tr>
                    <th>기업 소개 영상</th>
                    <td class="text-box">
                      <KSARadioButton class="check-box mr-lg" label="영상 업로드" v-model="createCorp.introMovGb" value="01" @change="resetFile('Y')" />
                      <KSARadioButton class="check-box mr-lg" label="유튜브 영상(URL) 등록" v-model="createCorp.introMovGb" value="02" @change="resetFile('N')" />
                      <div v-if="createCorp.introMovGb === '01'">
                        <div class="grid file mt-xs">
                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntroMov(createCorp)" />
                          <KSAInput class="input icon" v-model="createCorpIntroMovFileNameSize" placeholder="파일 선택" disabled />
                          <button class="delete" @click="removeFileCorpIntroMov(createCorp)"><i></i></button>
                        </div>
                        <small>최대 500MB 까지 첨부 가능</small>
                      </div>
                      <div v-else-if="createCorp.introMovGb === '02'">
                        <KSAInput class="text-box mt-xs" v-model="createCorp.introYoutubeUrl" maxLength="200" placeholder="유튜브 영상(URL) 경로를 https://를 포함하여 입력하세요." />
                      </div>
                      <p>
                        <small style="color:#E71414;">{{ inputError.introYoutubeUrl }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>기업 소개</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="user.corpIntro !== undefined" v-model="user.corpIntro" />
                    </td>
                  </tr>
                  <tr>
                    <th>주요 연혁</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="user.corpHistory !== undefined" v-model="user.corpHistory" @update:modelValue="validateText('corpHistory')" />
                      <!-- <p>
                        <small style="color:#E71414;">{{ inputError.corpHistory }}</small>
                      </p> -->
                    </td>
                  </tr>
                  <tr>
                    <th>기업 소개서</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(user)" />
                        <KSAInput class="input icon" v-model="corpFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileCorpIntro(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 추가 정보 -->
              <!-- s: 약관 동의 -->
              <div class="terms-wrap">
                <hr>
                <KSACheckBox label="기업정보 및 개인(담당자)정보의 수집 · 이용 · 제공 및 활용에 동의합니다." v-model="createCorp.corpInfoAgreePrivacyYn" /><span class="red">(필수)</span>
                <div class="terms-box">
                  1. 수집하는 기업정보 및 개인(담당자)정보 항목<br>
                  회사는 회사가 주최 및 주관하는 특별채용관의 참가 신청, 채용 공고 등록을 위한 기업정보 확인 등을 위해 아래와 같은 기업정보 및 개인(담당자)정보를 수집하고 있습니다.<br><br>

                  - 기업정보 : 사업자등록번호, 기업명, 대표자명, 사업장소재지, 업종, 산업군, 기업형태, 창립연월, 사원수, 매출액, 상장여부, 홈페이지, 로고, 사업자등록증, 기업소개, 주요연혁, 기업 소개서 등<br>
                  - 개인(담당자)정보 : 성명, 부서, 직위, 회사 직통번호, 휴대전화번호, 이메일 등<br><br>

                  2. 정보의 이용 목적 및 제공 범위<br>
                  회사는 수집한 기업정보 및 개인(담당자)정보를 다음의 목적을 위해 활용합니다.<br>

                  - 회원 관리 회원제 서비스 이용에 따른 기업 및 본인 확인, 개인 식별, 채용지원시스템 이용 확인, 문의사항 처리 및 공지사항 전달<br>
                  - 기업 홍보관의 기업정보 등록 및 확인을 위한 기업의 정보 확인 목적<br>
                  - 기업 홍보관의 이용 회원들이 확인할 수 있는 기업 정보의 제공 목적<br><br>

                  3. 정보 보유 및 이용기간<br>
                  회사는 수집한 기업정보 및 개인(담당자)정보를 이용목적이 달성된 후에는 정보를 관할 할 수 있는 기업회원탈퇴 및 기업정보삭제 요청시까지 보유하고 탈퇴 및 삭제요청 이후에는 해당 정보를 지체 없이 파기합니다.

                </div>
              </div>
              <!-- e: 약관 동의-->
            </div>
            <div class="btn-wrap space-between">
              <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(ojfId)" />
              <KSAPrimaryButton text="등록 완료" @click="saveCorp()" />
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.etc-box {
  display: inline-block;
  width: 200px;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          small {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
  .disabled {
    cursor: default;
    background: $gray-regular_color;
    border-color: $gray-regular_color;
    color: #fff;
  }
}

.terms-wrap {
  margin: 20px 0;

  > .check-box:first-child {
    @include font-size_md;
  }

  hr {
    border: $border_line;
    margin: 20px 0;
  }

  .terms-box {
    height: 180px;
    overflow-y: auto;
    @include font-size_xs;
    background: $gray-thin_color;
    border: $border_line;
    padding: 20px;
    margin: 10px 0 40px;
  }
}

:deep(.error-focus),
:deep(.error-focus input) {
  outline: 2px solid #E71414 !important;
  border-color: #E71414 !important;
}
</style>
